export default __webpack_public_path__ + "static/media/white_membershippass.dc06f086.svg";